import { render, staticRenderFns } from "./PaymentOption.vue?vue&type=template&id=2c5d3c12&scoped=true"
import script from "./PaymentOption.vue?vue&type=script&lang=js"
export * from "./PaymentOption.vue?vue&type=script&lang=js"
import style0 from "./PaymentOption.vue?vue&type=style&index=0&id=2c5d3c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5d3c12",
  null
  
)

export default component.exports